function remountTrixEditor(editor, inputId) {
  const parent = editor.parentNode
  if (!parent) return null

  const newEditor = document.createElement("trix-editor")
  Array.from(editor.attributes).forEach((attr) => {
    newEditor.setAttribute(attr.name, attr.value)
  })

  if (inputId) newEditor.setAttribute("input", inputId)
  newEditor.classList.add("trix-content")
  newEditor.style.minHeight = "5rem"
  newEditor.style.display = "block"

  parent.replaceChild(newEditor, editor)
  return newEditor
}

function editorInputId(editor) {
  const form = editor.closest("form")
  const hiddenInput = form?.querySelector('input[type="hidden"][name$="[body]"]')
  return hiddenInput?.id || editor.getAttribute("input")
}

function ensureTrixEditorMounted(editor, { force = false } = {}) {
  const inputId = editorInputId(editor)

  if (inputId) editor.setAttribute("input", inputId)

  editor.style.minHeight = "5rem"
  editor.style.display = "block"

  const toolbar = editor.previousElementSibling
  const hasToolbar = toolbar?.tagName === "TRIX-TOOLBAR"

  if (force || !hasToolbar) return remountTrixEditor(editor, inputId)

  void editor.offsetHeight
  return editor
}

export function refreshTrixEditors(container, { force = false } = {}) {
  if (!container) return

  container.querySelectorAll("trix-editor").forEach((editor) => {
    ensureTrixEditorMounted(editor, { force })
  })

  container.querySelectorAll("trix-toolbar").forEach((toolbar) => {
    toolbar.style.display = ""
    void toolbar.offsetHeight
  })
}
